import { render, staticRenderFns } from "./stockCardSummary.vue?vue&type=template&id=5344017b&"
import script from "./stockCardSummary.vue?vue&type=script&lang=js&"
export * from "./stockCardSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports